module.exports = __webpack_public_path__ + "img/2.7ed8be43.png";